import { LEGAL_CONFIG } from './config';
import './Legal.css';

/**
 * Chrome shared by the legal documents: brand mark, title, effective date.
 *
 * These pages are reachable without signing in (see App.js), because the
 * Google OAuth and Meta app reviews both fetch the URLs anonymously and a
 * login wall reads as a missing policy.
 */
export function LegalPage({ title, children }) {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <div className="legal-brand">
                    <img src="/logo192.png" alt="" />
                    <a href={LEGAL_CONFIG.siteUrl}>&larr; Back to {LEGAL_CONFIG.domain}</a>
                </div>

                <h1>{title}</h1>
                <p className="legal-effective">
                    Effective {LEGAL_CONFIG.effectiveDate}
                    {LEGAL_CONFIG.lastUpdated !== LEGAL_CONFIG.effectiveDate
                        ? ` · Last updated ${LEGAL_CONFIG.lastUpdated}`
                        : ''}
                </p>

                {children}
            </div>
        </div>
    );
}

export default LegalPage;
